import React, { useEffect, useState } from "react";
import { Grid, Typography, Tooltip } from "../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";

const MessageStatus = () => {
  const [messages, setMessages] = useState<any>([]);
  const handleGet = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/messages`);
      if (resp.status === 200) {
        setMessages(resp.data?.data);
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGet();
  }, []);
  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          {" "}
          <Typography fontSize={20} fontWeight={500} color="#111827">
            {" "}
            Message History
          </Typography>
        </Grid>

        <Grid
          size={12}
          container
          py={1}
          mt={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={3}>
            {" "}
            <Typography align="center" fontSize={15} fontWeight={500}>
              Message
            </Typography>
          </Grid>
          <Grid size={2}>
            {" "}
            <Typography align="center" fontSize={15} fontWeight={500}>
              Phone
            </Typography>
          </Grid>
          <Grid size={2}>
            {" "}
            <Typography align="center" fontSize={15} fontWeight={500}>
              Status
            </Typography>
          </Grid>
          <Grid size={2}>
            {" "}
            <Typography align="center" fontSize={15} fontWeight={500}>
              Platform
            </Typography>
          </Grid>
          <Grid size={2}>
            {" "}
            <Typography align="center" fontSize={15} fontWeight={500}>
              Reason
            </Typography>
          </Grid>
        </Grid>

        {messages?.map((item: any, index: any) => (
          <Grid size={12} container py={2} borderBottom={"1px solid #111827"}>
            <Grid size={3}>
              {" "}
              <Typography align="center" fontSize={15} fontWeight={500}>
                <Tooltip sx={{ fontSize: "14px" }} title={item?.message}>
                  {item?.message?.length > 50
                    ? `${item?.message?.slice(0, 50)}...`
                    : item?.message}
                </Tooltip>
              </Typography>
            </Grid>
            <Grid size={2}>
              {" "}
              <Typography align="center" fontSize={15} fontWeight={500}>
                {item?.phone}
              </Typography>
            </Grid>
            <Grid size={2}>
              {" "}
              <Typography
                color={item?.status === "success" ? "success" : "error"}
                align="center"
                fontSize={15}
                fontWeight={500}
              >
                {item?.status}
              </Typography>
            </Grid>
            <Grid size={2}>
              {" "}
              <Typography align="center" fontSize={15} fontWeight={500}>
                {item?.platform}
              </Typography>
            </Grid>
            <Grid size={2}>
              {" "}
              <Typography align="center" fontSize={15} fontWeight={500}>
                <Tooltip title={item?.reason}>
                  {item?.reason?.length > 30
                    ? `${item?.reason?.slice(0, 30)}...`
                    : item?.reason}
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default MessageStatus;
